module.exports = __webpack_public_path__ + "img/invite-member-top.dbf635d4.svg";